$(document).ready(function(){
	//CKEDITOR Library
	//$.getScript('https://cdn.ckeditor.com/4.16.0/standard/ckeditor.js');
	
	//BookAnAppoinment
	var isRomania = $('html').attr('data-bank') == 'ISPROMANIA';
	if(isRomania){
		$('select[name*="selectBranch"]').on("change", function(){
	        $('input[name*="selectBranchEmail"]').val($(this).find("option:selected").val());
	        $('input[name*="selectBranchLocation"]').val($(this).find("option:selected").text().trim());
		});
		
		//Complaints
		var firstNameRequired = $("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="firstname"]').attr("required");
		var companyNameRequired = $("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="companyName"]').attr("required");
		var cnpNumberRequired = $("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]').attr("required");
		var cuiNumberRequired = $("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]').attr("required");
		
		$('select[name*="selectSubject"]').on("change", function(){
	        $('input[name*="selectSubjectValue"]').val($(this).find("option:selected").val());
	        $('input[name*="selectSubjectLabel"]').val($(this).find("option:selected").text().trim());
		});
		
		complaintRadioTypeClient(firstNameRequired, companyNameRequired, cnpNumberRequired, cuiNumberRequired);
		$("#radioTypeClient").closest(".for__radio__group").on("click", function(){
			complaintRadioTypeClient(firstNameRequired, companyNameRequired, cnpNumberRequired, cuiNumberRequired);
		});
		
		setTimeout(function() {
			addCNP_CUI_Validations($("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]'),
					$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]'));
		}, 1000);
		
		//Get value GDPR
		$('input[name="gdprPrivacyHtml"]').on("change", function(){
			$('input[name="gdprPrivacy"]').val($('input[name="gdprPrivacyHtml"]').prop('checked'));
		});
	}
	
});

function complaintRadioTypeClient(firstNameRequired, companyNameRequired, cnpNumberRequired, cuiNumberRequired){
	console.log("complaintRadioTypeClient - method");
	
	if($("#radioTypeClient:checked").val() == 'individual'){
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="firstname"]').parent().parent().show();
		if(firstNameRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="firstname"]').attr("required", "required");
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="companyName"]').parent().parent().hide();
		if(companyNameRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="companyName"]').removeAttr("required");
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]').parent().parent().show();
		if(cnpNumberRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]').attr("required", "required");
			
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]').parent().parent().hide();
		if(cuiNumberRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]').removeAttr("required");
			
	}else if($("#radioTypeClient:checked").val() == 'business'){
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="firstname"]').parent().parent().hide();
		if(firstNameRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="firstname"]').removeAttr("required");
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="companyName"]').parent().parent().show();
		if(companyNameRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="companyName"]').attr("required", "required");
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]').parent().parent().hide();
		if(cnpNumberRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cnpNumber"]').removeAttr("required");
		
		$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]').parent().parent().show();
		if(cuiNumberRequired != undefined)
			$("#radioTypeClient:checked").closest('.for__gridWrapper').find('input[name="cuiNumber"]').attr("required", "required");
		
	}
}

function addCNP_CUI_Validations(inputCNP, inputCUI){
	console.log("addCNP_CUI_Validations - method");
	
	$(inputCNP).attr("data-parsley-cnp", "");
	$(inputCUI).attr("data-parsley-cui", "");
	
	window.Parsley.addValidator('cnp', {
	  validateString: function(value) {
	    return validateCNP(value);
	  }
	});
	
	window.Parsley.addValidator('cui', {
	  validateString: function(value) {
	    return validateCUI(value);
	  }
	});
}

function validateCUI(cui){
	var cif = cui;
    // Daca este string, elimina atributul fiscal si spatiile
    if(isNaN(parseFloat(cui)) || !isFinite(cui)){
      cif = cif.toUpperCase();
      if(cif.indexOf('RO') === 0){
        cif = cif.replace('RO', '');
      } else {
        return false;
      }
      cif = parseInt(cif.trim());
    } else {
      cif = parseInt(cif);
    }
    // daca are mai mult de 10 cifre sau mai putin de 6, nu-i valid
    if(cif.toString().length > 10 || cif.toString().length < 4){
      return false;
    }
    // numarul de control
    var v = 753217532;

    // extrage cifra de control
    var c1 = parseInt(cif % 10);
    cif = parseInt(cif / 10);

    // executa operatiile pe cifre
    var t = 0;
    while (cif > 0) {
      t += (cif % 10) * (v % 10);
      cif = parseInt(cif / 10);
      v = parseInt(v / 10);
    }

    // aplica inmultirea cu 10 si afla modulo 11
    var c2 = parseInt((t * 10) % 11);
    // daca modulo 11 este 10, atunci cifra de control este 0
    if(c2 == 10){
      c2 = 0;
    }

    return c1 === c2;
}

function validateCNP(value) {
    // 0: cnp
    // 1: s (1-8)
    // 2: aa (00-99)
    // 3: ll (01-12)
    // 4: zz (01-31)
    // 5: jj (1-46, 51-52)
    // 6: nnn (001-999)
    // 7: c (279146358279)
    var m
    if (m = /^([1-8])(0[1-9]|[1-9][0-9])(0[1-9]|1[0-2])(\d{2})(\d{2})(\d{3})(\d)$/.exec(value)) {
        var ll = parseInt(m[3])
        var zz = parseInt(m[4])
        switch (ll) {
            case 2:
                if (zz > 29) {
                    return false
                }
            case 3:
            case 4:
            case 6:
            case 9:
            case 11:
                if (zz > 30) {
                    return false
                }
            default:
                if (zz > 31) {
                    return false
                }
        }
        var jj = parseInt(m[5])
        if (jj < 0 || (jj > 46 && jj < 51) || jj > 52) {
            return false
        }
        var nnn = parseInt(m[6])
        if (nnn < 0) {
            return false
        }
        var c = parseInt(m[7])
        var constanta = "279146358279"
        var suma = 0
        for(var i = 0; i < constanta.length; i++) {
            suma = suma + parseInt(m[0].charAt(i)) * constanta.charAt(i)
        }
        var rest = suma % 11
        return (((rest < 10) && (rest == m[0].charAt(12))) || ((rest == 10) && (m[0].charAt(12) == 1))) ? true : false
    }
    return false
}